export const FILTERS = [
  { label: 'All plans', value: 'all', icon: 'airplane-takeoff' },
  { label: 'Paid in full', value: 'in-full', icon: 'currency-circle-dollar' },
  { label: 'Active', value: 'active', icon: 'skip-forward-circle' },
  { label: 'On Track', value: 'ontrack', icon: 'check-circle' },
  { label: 'Late 0 - 7 days', value: 'late0d', icon: 'clock' },
  { label: 'Late 7 - 14 days', value: 'late7d', icon: 'alarm' },
  { label: 'Late 14+ days', value: 'late14d', icon: 'warning-circle' },
  { label: 'Halted (Invalid Card)', value: 'halted', icon: 'credit-card' },
  { label: 'Loss Recovery', value: 'lossrecovery', icon: 'skip-back-circle' },
  { label: 'Suspended', value: 'suspended', icon: 'pause-circle' },
  { label: 'Finished', value: 'completed', icon: 'check-square' },
]
